import { change   as reduxFormChange}     from 'redux-form';
import { untouch  as reduxFormUntouch}    from 'redux-form';



///////////////////////////////////////////////////////////////////////////
//
// FormAdapter
//
// Redux-Form made easy! Create new instance for your form today, and read/write any field with ease!
//
//    readField    ===> Get Field Value.
//    changeField  ===> Set new value to the Field.
//    extendNew    ===> create new Adapted for a deeper field.
//
//
//
// EXAMPLE:
//
//    let myFormAdapter = new FormAdapter(dispatch, getState, 'MY_AWESOME_FORM_NAME');
//
//    if (myFormAdapter.readField('businessId') === 'AWESOME') {
//      myFormAdapter.changeField('comments', 'Yay!');
//    }
//
//
//
// Create adapter extension for inner objects!
//
// EXAMPLE:
//
//    let itemAdapter = myFormAdapter.extendNew('someItemsList[' + 3 + ']');
//
//    itemAdapter.changeField('statusDropDown', null, true);
//
//
//


// Constructor.
export function FormAdapter(dispatch, getState, formName, path = '') {

  this.dispatch = dispatch;
  this.getState = getState;
  this.formName = formName;
  this.path     = path;

  this.extendNew = function(additionalPath) {
    return new FormAdapter(this.dispatch, this.getState, this.formName, this.fullPath(additionalPath));
  };

  this.fullPath = function(fieldName) {
    if (this.path === '') {
      return fieldName;
    }
    return (this.path + '.' + fieldName);
  };


  this.printDebug = function() {
    // console.debug('FormAdapter created for path ===> ', this, this.fullPath('SOMEPROPNAME'));
  };


  this.changeField = function(fieldName, value, clearErrors = false) {

    dispatch(reduxFormChange(this.formName, this.fullPath(fieldName), value));

    // Clear error if requested.
    if (clearErrors) {
      dispatch(reduxFormUntouch(this.formName, this.fullPath(fieldName)));
    }

    // Enable changeField() chainging.
    return this;
  };


  this.readField = function(fieldName) {
    return findFormValue(dispatch, getState)(this.formName, this.fullPath(fieldName));
  };


}







///////////////////////////////////////////////




let findFormValue = function(dispatch, getState) {
  return function(formName, fieldPath) {

    let allFormsData  = getState().form;
    let formData      = allFormsData[formName];
    if (!formData) {
      console.error('findFormValue => cannot find data for form - "' + formName + '"');
      return undefined;
    }

    let formValues    = formData.values;
    if (!formValues) {
      //console.error('findFormValue => form has no values - "' + formName + '"');
      return undefined;
    }

    //let foundValue    = formValues[fieldPath];
    //let foundValue    = Object.byString(formValues, fieldPath);
    let foundValue    = objectByString(formValues, fieldPath);


    if (foundValue !== undefined) {
      return JSON.parse(JSON.stringify(foundValue)); // Deep clone result.
    }

    return undefined;

  }
};


let objectByString = function(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
        let k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
};






